
import React from 'react';

const messageContext = React.createContext();
const {Provider} = messageContext;

export const useMessage = () => {
    return React.useContext(messageContext);
};


export const MessageProvider = ({children}) => {


    const [message, _setMessage] = React.useState({
        message: undefined,
        type: undefined,
        description: undefined
    })

    function setError(value) {
        setMessage(value, "error");
    };

    function setMessage(value, typ) {

        const msg = document.getElementById("global_message");
        if (msg) {
            msg.style.transition = '.5s';
            msg.style.opacity = '100';
            msg.style.visibility = 'visible';
        };

        if (!typ) {
            typ = "ok";
        };

        if (typeof value == "string") {
            value = { type: typ,
                      message: value,
                      description: "" };
        };

        if (value && value.type) {
            setTimeout(() => {
                const msg = document.getElementById("global_message");
                msg.style.transition = '2s';
                msg.style.opacity = '0';
                msg.style.visibility = 'hidden';
            }, 2000 + value.message.length * 100);
        };
        return _setMessage(value);
    };

    return (
    <Provider value={{message, setMessage, setError}}>
        <Message />
        {children}
    </Provider>
    )
}


function Message() {

    const { message } = useMessage();

    if (message.type) {
        const col = {
            ok: {bg: "bg-teal-100", bo: "border-teal-500", txt: "text-teal-900", svg: "text-teal-500"},
            info: {bg: "bg-yellow-100", bo: "border-yellow-500", txt: "text-yellow-900", svg: "text-yellow-500"},
            alert: {bg: "bg-red-100", bo: "border-red-500", txt: "text-red-900", svg: "text-red-500"},
            error: {bg: "bg-red-100", bo: "border-red-500", txt: "text-red-900", svg: "text-red-500"}
        }[message.type]
        return (
            <div id="global_message" className={`absolute w-1/1 ${col.bg} border-t-4 ${col.bo} rounded-b ${col.txt} px-4 py-3 shadow-md`} role={`${message.type}`}>
              <div className="flex">
                <div className="py-1">
                    <svg className={`fill-current h-6 w-6 ${col.svg} mr-4`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/></svg>
                </div>
                <div>
                  <p className="font-bold">{message.message}</p>
                  <p className="text-sm">{message.description}</p>
                </div>
              </div>
            </div>
        )
    }

}
